var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M76 56c5.96-5.84 12-12.84 12-22a22 22 0 0 0-22-22c-7.04 0-12 2-18 8-6-6-10.96-8-18-8A22 22 0 0 0 8 34c0 9.2 6 16.2 12 22l28 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M48 20 36.16 31.84a8.68 8.68 0 0 0 0 12.32c3.28 3.28 8.52 3.4 12 .28l8.28-7.6a11.28 11.28 0 0 1 15.16 0l11.84 10.64M72 60l-8-8M60 72l-8-8"
  })));
};
export default SvgHeart;